import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements, modifiers } from '../styles.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    checkbox
  ) => {
    const fieldset = closest(`.${elements.fieldset}, .${elements.new_fieldset}`, checkbox)
    const input = one(`.${modifiers.field_input.password}, .${modifiers.new_field_input.new_password}`, fieldset)

    if (input) {
      input.type = input.type === 'password' ? 'text' : 'password'
    }
  }
})

export default checkbox => {
  onInput.listen(checkbox)
}